export default __webpack_public_path__ + "static/media/exploration-quest-transparent.41461b33.png";